import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import RentDetails from "./RentDetails";
import PersonalDetails from "./PersonalDetails";
import GuardianDetails from "./GuardianDetails";
import OccupationDetails from "./OccupationDetails";
import { useSelector } from "react-redux";
import StudentDetails from "./StudentDetails";

export default function TenantInfo({
  data,
  error,
  isLoading,
  setSelectedData,
  selectedData,
  isRefetching,
  addRentDetailMutate,
  addPersonalDetailMutate,
  addGuardianDetailMutate,
  addOccupationDetailMutate,
  isRentDetailLoading,
  isPersonalDetailLoading,
  isGuardianDetailLoading,
  isOccupationDetailLoading,
}) {
  const user = useSelector((state) => state.UserReducer.user);
  const occupation = data?.tenant?.occupation || "";

  return (
    <>
      <Wrapper>
        {/* Rent Details Section */}
        <>
          <RentDetails
            tenantData={data}
            addRentDetailMutate={addRentDetailMutate}
            isRentDetailLoading={isRentDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
          />
        </>

        {/* Personal Details Section */}
        <>
          <PersonalDetails
            tenantData={data}
            addPersonalDetailMutate={addPersonalDetailMutate}
            isPersonalDetailLoading={isPersonalDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
          />
        </>

        {/* Guardian Details Section */}
        <>
          <GuardianDetails
            tenantData={data}
            addGuardianDetailMutate={addGuardianDetailMutate}
            isGuardianDetailLoading={isGuardianDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
          />
        </>

        {/* Occupation Details Section */}
        {occupation === "Student" ? (
          <StudentDetails
            tenantData={data}
            addOccupationDetailMutate={addOccupationDetailMutate}
            isOccupationDetailLoading={isOccupationDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
          />
        ) : (
          <OccupationDetails
            tenantData={data}
            addOccupationDetailMutate={addOccupationDetailMutate}
            isOccupationDetailLoading={isOccupationDetailLoading}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
          />
        )}
      </Wrapper>
    </>
  );
}

const Wrapper = tw.div`px-4 py-2  space-y-4 `;
